/* src/app/modules/assessments/assessments/assessments.component.scss */
.assessment-wrapper {
  background-color: var(--white);
  margin-top: -1rem;
  padding-top: 0.313rem;
  min-height: 100%;
  width: 100%;
}
.assessment-wrapper .content {
  width: 100%;
}
.assessment-wrapper .content #mainAssessments {
  position: relative;
  width: 100%;
  max-width: 80rem;
  height: calc(100vh - 7.5rem);
}
.greeting__title {
  font-size: 2.5em;
  line-height: 1em;
  padding-top: 0.5rem;
}
/*# sourceMappingURL=assessments.component.css.map */
